import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { Reveal } from "./Reveal";
import { InquiryForm } from "./InquiryForm";

const BRANCH_CARDS = [
  {
    id: "manesar",
    city: "Manesar, Gurugram",
    region: "Haryana",
    note: "Ask about visit arrangements and current admissions information.",
  },
  {
    id: "up",
    city: "Sandila & Bharawan",
    region: "Uttar Pradesh",
    note: "Contact us to confirm branch addresses, programme availability and timings.",
  },
];

export const Contact = () => (
  <section id="contact" data-testid="contact-section" className="relative py-24 lg:py-32 bg-mint/40">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Reveal className="max-w-2xl">
        <span className="inline-block text-xs font-bold tracking-[0.24em] uppercase text-peach mb-4">
          Contact Us
        </span>
        <h2 className="font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-[1.08] text-ink">
          Visit us, or just{" "}
          <em className="font-quote italic font-medium text-sage">say hello</em>
        </h2>
      </Reveal>

      <div className="mt-14 grid lg:grid-cols-2 gap-10 lg:gap-16 items-start">
        <div className="space-y-5">
          {BRANCH_CARDS.map((b, i) => (
            <Reveal key={b.id} delay={i * 0.1}>
              <div
                data-testid={`branch-card-${b.id}`}
                className="bg-white border border-ink/6 rounded-[1.75rem] p-7 soft-shadow hover:soft-shadow-lg transition-shadow"
              >
                <div className="flex items-start justify-between gap-4">
                  <div>
                    <h3 className="font-display font-bold text-xl text-ink flex items-center gap-2.5">
                      <MapPin className="w-5 h-5 text-peach shrink-0" />
                      {b.city}
                    </h3>
                    <span className="ml-7 text-xs font-semibold tracking-wider uppercase text-sage">
                      {b.region}
                    </span>
                  </div>
                </div>
                <p className="mt-4 ml-0 text-sm text-ink/60 leading-relaxed">{b.note}</p>
                <div className="mt-5 flex flex-wrap gap-x-6 gap-y-2 ml-0 text-sm font-medium">
                  <a href="tel:+919711245316" className="inline-flex items-center gap-2 text-ink/75 hover:text-peach transition-colors">
                    <Phone className="w-4 h-4 text-sage" /> +91 97112 45316
                  </a>
                  <a
                    href="mailto:kiwikids.playschool1@gmail.com"
                    className="inline-flex items-center gap-2 text-ink/75 hover:text-peach transition-colors"
                  >
                    <Mail className="w-4 h-4 text-sage" /> kiwikids.playschool1@gmail.com
                  </a>
                </div>
              </div>
            </Reveal>
          ))}

          <Reveal delay={0.2}>
            <div className="rounded-[1.75rem] bg-forest text-cream p-7 flex items-center gap-4">
              <span className="shrink-0 w-12 h-12 rounded-2xl bg-sun/20 flex items-center justify-center">
                <Clock className="w-6 h-6 text-sun" />
              </span>
              <p className="text-sm text-cream/80 leading-relaxed">
                Open Monday to Saturday. Call <a href="tel:+919711245316" className="font-bold text-sun whitespace-nowrap">+91 97112 45316</a> to
                schedule a campus visit — little visitors are very welcome.
              </p>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.15}>
          <div className="bg-white border border-ink/6 rounded-[2rem] p-7 sm:p-9 soft-shadow-lg">
            <h3 className="font-display font-bold text-2xl text-ink mb-1.5">Request a call back</h3>
            <p className="text-sm text-ink/55 mb-7">
              Tell us a little about your child — we'll take it from there.
            </p>
            <InquiryForm />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
